export interface IUserModel {
  userId: number;
  authUserId: number;
  firstName: string | undefined;
  lastName: string | undefined;
  emailAddress: string | undefined;
  objectIdentifier: string | undefined;
  allowSecurityAdmin: boolean;
}

export class UserModel implements IUserModel {
  userId: number;
  authUserId: number;
  firstName: string | undefined;
  lastName: string | undefined;
  emailAddress: string | undefined;
  objectIdentifier: string | undefined;
  allowSecurityAdmin: boolean;

  constructor(params: Partial<IUserModel>) {
    const {
      userId = 0,
      authUserId = 0,
      firstName = undefined,
      lastName = undefined,
      emailAddress = undefined,
      objectIdentifier = undefined,
      allowSecurityAdmin = false,
    } = params;

    this.userId = userId;
    this.authUserId = authUserId;
    this.firstName = firstName;
    this.lastName = lastName;
    this.emailAddress = emailAddress;
    this.objectIdentifier = objectIdentifier;
    this.allowSecurityAdmin = allowSecurityAdmin;
  }
}
